export default __webpack_public_path__ + "static/media/002-Beagle.c4eae2af.svg";